import { render } from "./loginHeader.vue?vue&type=template&id=67d77bd4&scoped=true"
import script from "./loginHeader.vue?vue&type=script&lang=js"
export * from "./loginHeader.vue?vue&type=script&lang=js"

import "./loginHeader.vue?vue&type=style&index=0&id=67d77bd4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d77bd4"]])

export default __exports__